import React from 'react';

const assetPath = '/themes/app/assets/images/';

const Toggle = ({updateLayout, selected='grid', partsDetails}) => (
  <div className='c-Toggle'>
    <p><strong>Click icons to change product layout</strong></p>
    <button className='c-Toggle__button' onClick={() => updateLayout('grid')}>
      <img src={selected === 'grid' ? `${assetPath}grid-toggle-active.svg` : `${assetPath}grid-toggle.svg`} />
    </button>
    <button className='c-Toggle__button' onClick={() => updateLayout('list')}>
      <img src={selected === 'list' ? `${assetPath}list-toggle-active.svg` : `${assetPath}list-toggle.svg`} />
    </button>
    <p>{partsDetails.matching} matching parts out of {partsDetails.total}</p>
  </div>
);

export default Toggle;



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/product/js/Toggle.js